/**
 * The empty state every area starts with: what it is for in one line, three
 * benefits, and either its first action or, while the area is still being
 * built, a plain "being built" note — never a button that does nothing.
 */

import type { ReactNode } from 'react';

export function EmptyFeature({
  title,
  lead,
  points,
  action,
}: {
  title: string;
  lead: string;
  points: [string, string, string];
  /** The first thing to do here; absent while the area is still being built. */
  action?: { label: string; onClick: () => void } | undefined;
}): ReactNode {
  return (
    <div className="ag-feature">
      <h2>{title}</h2>
      <p className="ag-feature-lead">{lead}</p>
      <ul>
        {points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
      {action ? (
        <button type="button" className="btn" onClick={action.onClick}>
          {action.label}
        </button>
      ) : (
        <p className="ag-feature-soon">
          Being built — part of matching AgencyAnalytics feature for feature.
        </p>
      )}
    </div>
  );
}
